<script>
import { i18n } from "utils/util";
export default {
  props: {
    data: [Array],
  },
  inject: ["isUseI18n", "slideUpIn"],
  data() {
    this.els = [];
    return {};
  },
  mounted() {
    $(document)
      .off("mousemove.parallaxBg")
      .on("mousemove.parallaxBg", (ev) => this.parallax_effect(ev));

    let children = $(this.$refs.bgBox).find(".parallax-item");
    this.els = [children.eq(0), children.eq(1)];
  },
  beforeDestroy() {
    $(document).off("mousemove.parallaxBg");
  },
  methods: {
    get_img_link(item) {
      return this.isUseI18n ? i18n(item) : item;
    },
    parallax_effect(ev) {
      //  如果 slide up in 动画还未执行完直接跳过
      if ($(this.els[1]).hasClass("slide-up-in-stage")) return;
      //  添加front-end效果事件监听
      let factorX = -2 * (ev.clientX / window.innerWidth - 0.5);
      let factorY =
        -2 * ((ev.clientY - 100) / (window.innerHeight - 100) - 0.5);
      let x = Math.round((0.5 * 20 * Math.round(factorX * 100)) / 100) * 2;
      let y =
        Math.round(
          0.5 * Math.max(-50, (20 / 4) * (Math.round(factorY * 100) / 100))
        ) * 2;

      this.els[0].velocity("stop").velocity(
        {
          translateX: x,
          translateY: y,
        },
        {
          easing: "easeOutSine",
          duration: 500,
        }
      );

      x = Math.round((0.5 * 10 * Math.round(factorX * 100)) / 100) * 2;
      y =
        Math.round(
          0.5 * Math.max(-50, (10 / 4) * (Math.round(factorY * 100) / 100))
        ) * 2;

      this.els[1].velocity("stop").velocity(
        {
          translateX: x,
          translateY: y,
        },
        {
          easing: "easeOutSine",
          duration: 500,
        }
      );
    },
  },
  render(h) {
    const classObj = {
      "parallax-bg": true,
    };

    return (
      <div class={classObj} ref="bgBox">
        {this.data.map((item, index) => {
          let styleObj = {
            "background-image": `url(${this.get_img_link(item)})`,
            zIndex: index + 1,
          };

          let slideUpInStage = false;

          //  第一张背景图是不需要加slide up in效果的
          if (this.slideUpIn && index > 0) {
            slideUpInStage = index;
          }

          return (
            <div class="parallax-wrap">
              <div
                class="parallax-item"
                style={styleObj}
                key={item}
                vSlideUpInStage={slideUpInStage}
              />
            </div>
          );
        })}
      </div>
    );
  },
};
</script>

<style lang="scss">
.parallax-bg {
  position: relative;
  width: 100%;
  height: 100%;
  transform: scale(1.04);
}

.parallax-wrap,
.parallax-item {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.parallax-item {
  background-size: cover;
  background-position: center;
}

body:not(.ie11){
  .parallax-wrap,
  .parallax-item {
    will-change: transform;
    transition: transform 2s cubic-bezier(0, 0.55, 0.45, 1);
  }
}
</style>
